export const APP_VERSION_STRING = "0.11.0";
